import { PrimaryButton } from "@graffer-inc/console-design-kit";
import React from "react";
import { useHistory } from "react-router-dom";
import { RBACHidden } from "../../../helpers/rbac/rbac";
import { TtzkPortalR } from "../../../pages/ttzk-portal/route";

export const MainMenu: React.FC = () => {
  const history = useHistory();
  return (
    <div className="columns">
      <div className="column has-text-right buttons">
        <RBACHidden requirePermissions="ttzk_portal.shortcuts.create">
          <PrimaryButton
            text="ショートカット新規作成"
            onClick={() => {
              history.push(TtzkPortalR.ShortcutCreate.link({}));
            }}
          />
        </RBACHidden>
      </div>
    </div>
  );
};

export default MainMenu;
